/* KAT · JS compartido: carrito (localStorage), menú móvil y acordeón FAQ.
   Se usa en test.html y faq.html. El carrito se ve y funciona igual que en el home. */
(function(){
  var cart = [];
  try{ cart = JSON.parse(localStorage.getItem('kat_cart')||'[]'); }catch(e){ cart=[]; }
  function save(){ try{ localStorage.setItem('kat_cart', JSON.stringify(cart)); }catch(e){} }
  var fmt = function(n){ return '$'+(n||0).toLocaleString('es-CO').replace(/,/g,'.'); };
  var PROMOS = {'BIENVENIDO5':0.05};
  var promo = parseFloat(localStorage.getItem('kat_promo'))||0;

  var drawer=document.getElementById('cartDrawer'), overlay=document.getElementById('cartOverlay'),
      itemsEl=document.getElementById('cartItems'), totalEl=document.getElementById('cartTotal'),
      countEl=document.getElementById('cartCount'), footEl=document.getElementById('cartFoot'),
      promoMsg=document.getElementById('promoMsg'),
      saveRow=document.getElementById('cartSavings'), saveAmt=document.getElementById('cartSavingsAmt');

  function openCart(){ drawer.classList.add('open'); overlay.classList.add('open'); }
  function closeCart(){ drawer.classList.remove('open'); overlay.classList.remove('open'); }

  function render(){
    if(!itemsEl) return;
    var count = cart.reduce(function(s,i){return s+i.qty;},0);
    countEl.textContent = count;
    countEl.style.display = count ? 'grid' : 'none';
    if(!cart.length){
      itemsEl.innerHTML='<div class="cart-empty">Tu carrito está vacío <span class="ic-paw"></span></div>';
      footEl.style.display='none'; save(); return;
    }
    footEl.style.display='block';
    var COVERS={'KAT LUNA':AB+'arenero-rona.png','KAT ASTRO':AB+'arenero-galactico.png','KAT COSMOS':AB+'arenero-abierto-1.png','KAT FLOW':AB+'fuente-prop.png','KAT KRONCH':AB+'comedero-prop.png'};
    itemsEl.innerHTML = cart.map(function(i,idx){
      return '<div class="ci">'+
        '<img src="'+(COVERS[i.name]||i.img)+'" alt="">'+
        '<div class="info"><div class="nm">'+i.name+'</div>'+
          '<div class="meta">'+i.color+'</div>'+
          '<div class="ci-qty"><button data-d="-1" data-i="'+idx+'">−</button><span>'+i.qty+'</span><button data-d="1" data-i="'+idx+'">+</button></div>'+
        '</div>'+
        '<div style="text-align:right"><div class="ln">'+fmt(i.unit*i.qty)+'</div><button class="rm" data-rm="'+idx+'">Quitar</button></div>'+
      '</div>';
    }).join('');
    var subtotal = cart.reduce(function(s,i){return s+i.unit*i.qty;},0);
    var units = count;
    var kitRate = units>=4?0.20 : units===3?0.15 : units>=2?0.10 : 0;
    var comboDesc = Math.round(subtotal*kitRate);
    var promoDesc = Math.round(subtotal*promo);
    var finalTotal = subtotal - comboDesc - promoDesc;
    var original = cart.reduce(function(s,i){return s+(i.was||i.unit)*i.qty;},0);
    var savings = original - finalTotal;
    totalEl.textContent = fmt(finalTotal);
    if(saveRow){ if(savings>0){ saveRow.hidden=false; saveAmt.textContent=fmt(savings); } else { saveRow.hidden=true; } }
    var nx = units<2?{n:2-units,r:10} : units<3?{n:1,r:15} : units<4?{n:1,r:20} : null;
    var msg = kitRate>0
      ? '💫 <b>Combo '+Math.round(kitRate*100)+'% OFF activado</b>'+(nx?' · suma '+nx.n+' '+(nx.n>1?'productos':'producto')+' y sube a '+nx.r+'%':' · ¡es el máximo! 🚀')
      : '🪐 Suma 1 producto más y activa <b>10% OFF</b> en tu combo';
    var kitEl=document.getElementById('cartKit');
    if(!kitEl){ kitEl=document.createElement('div'); kitEl.id='cartKit'; kitEl.className='cart-kit'; footEl.insertBefore(kitEl, footEl.firstChild); }
    kitEl.innerHTML=msg;
    save();
  }

  function applyPromo(){
    var inp=document.getElementById('promoInput'); if(!inp) return;
    var code=(inp.value||'').trim().toUpperCase();
    if(PROMOS[code]){ promo=PROMOS[code]; localStorage.setItem('kat_promo',promo); promoMsg.textContent='✓ Código aplicado: '+Math.round(promo*100)+'% de descuento'; render(); }
    else { promo=0; localStorage.removeItem('kat_promo'); promoMsg.textContent='Código no válido 😿'; render(); }
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    var fq = t.closest && t.closest('.faq-q');
    if(fq){ fq.parentElement.classList.toggle('open'); return; }
    if(t.closest && t.closest('#menuIcon')){ document.getElementById('mobileMenu').classList.toggle('open'); return; }
    if(t.closest && t.closest('#cartBtn')){ render(); openCart(); return; }
    if(t.id==='promoApply'){ applyPromo(); return; }
    if(t.id==='cartClose' || t.id==='cartOverlay'){ closeCart(); return; }
    if(t.dataset && t.dataset.d!==undefined){
      var it=cart[+t.dataset.i]; if(it){ it.qty+=+t.dataset.d; if(it.qty<1) it.qty=1; if(it.qty>99) it.qty=99; render(); } return;
    }
    if(t.dataset && t.dataset.rm!==undefined){ cart.splice(+t.dataset.rm,1); render(); return; }
  });

  render();
})();
